import React, { useState, useRef, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { Info } from 'lucide-react';

const InfoTooltip = ({ text, children }) => {
  const [pos, setPos] = useState(null);
  const iconRef = useRef(null);

  const handleEnter = useCallback(() => {
    if (!iconRef.current) return;
    const rect = iconRef.current.getBoundingClientRect();
    const tipW = 256; // w-64 = 16rem = 256px
    let left = rect.left + rect.width / 2 - tipW / 2;
    if (left < 8) left = 8;
    if (left + tipW > window.innerWidth - 8) left = window.innerWidth - 8 - tipW;
    setPos({ top: rect.top - 8, left, arrowLeft: rect.left + rect.width / 2 });
  }, []);

  return (
    <span className="inline-flex items-center">
      {children}
      <span ref={iconRef} className="ml-1 cursor-help" style={{ color: '#737373' }} onMouseEnter={handleEnter} onMouseLeave={() => setPos(null)}>
        <Info className="w-3.5 h-3.5" />
      </span>
      {pos && createPortal(
        <div style={{
          position: 'fixed', zIndex: 9999,
          left: pos.left, top: pos.top, width: 256,
          transform: 'translateY(-100%)',
          background: '#1A1A1A', border: '1px solid #333333', borderRadius: '4px',
          color: '#FCFCFC', fontFamily: "'Outfit', sans-serif", fontWeight: 300,
          padding: '8px', fontSize: '12px', lineHeight: 1.4,
          pointerEvents: 'none',
        }}>
          {text}
          <div style={{
            position: 'absolute', top: '100%',
            left: pos.arrowLeft - pos.left,
            transform: 'translateX(-50%)',
            marginTop: -1,
            width: 0, height: 0,
            borderLeft: '4px solid transparent', borderRight: '4px solid transparent',
            borderTop: '4px solid #333333',
          }} />
        </div>,
        document.body
      )}
    </span>
  );
};

export default InfoTooltip;
